"use client";

import type { FC, Ref } from "react";
import { AnalysisLoader, type AnalysisLoaderProps } from "@huub-web/shared";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface AnalysisLoaderTemplateProps {
  id?: string;
  title?: AnalysisLoaderProps["title"];
  templates?: TemplateCollection;
  description?: AnalysisLoaderProps["description"];
  variant?: AnalysisLoaderProps["variant"];
  error?: AnalysisLoaderProps["error"];
  steps?: AnalysisLoaderProps["steps"];
}

/**
 * AnalysisLoaderTemplate is a template that displays a loading state with a title, description, and templates.
 */
export const AnalysisLoaderTemplate: FC<
  AnalysisLoaderTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({
  templates,
  description,
  id,
  title,
  variant = "dynamic",
  error = false,
  steps,
  ref,
}) => (
  <AnalysisLoader
    id={id}
    ref={ref}
    title={title}
    description={description}
    variant={variant}
    error={error}
    steps={steps}
  >
    {templates && templates.length > 0 && (
      <TemplatesParser templates={templates} level={1} />
    )}
  </AnalysisLoader>
);
